module.exports = __webpack_public_path__ + "static/media/wold-modal.9314bb1f.gif";